// extracted by mini-css-extract-plugin
module.exports = {"userSelectionBlock":"UserSelectionBlock_userSelectionBlock__1Kpfy","blockHeading":"UserSelectionBlock_blockHeading__asjtd","cardList":"UserSelectionBlock_cardList__2ITWq"};